<script>
export default {
    name: "ActionDropdown",

    props: {
        action: {
            type: String,
            required: true,
        }
    }
}
</script>
<template>
    <div class="dropdown inline-block relative">
      <button class="bg-blue-400 justify-center text-white font-semibold py-1 px-2 rounded inline-flex items-center">
        <span class="mr-1">{{ action }}</span>
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> 
        </svg>
      </button>
      <ul class="dropdown-menu absolute hidden text-gray-700 pt-1 z-50">
        <slot name="buttons"></slot>
      </ul>
    </div>
</template>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}
</style>